import propertyMarker from 'images/property_marker.png';
import {getIn} from 'lib/immutableObject';
import PropTypes from 'prop-types';
import {Component} from 'react';
import {Button, Checkbox, Modal} from 'semantic-ui-react';
import './LocationPickerMap.scss';

export default class LocationPickerMap extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    singleLineAddress: PropTypes.string,
    onSelectLocation: PropTypes.func.isRequired,
  };

  state = {
    updateCorelogic: false,
  };

  componentDidMount() {
    this.mountMaps();
  }

  componentDidUpdate(prevProps) {
    const {open} = this.props;
    if (open && !prevProps.open) {
      this.mountMaps();
    }
  }

  _propertyMarker = null;

  mountMaps = () => {
    const {open, singleLineAddress} = this.props;

    if (open && this._mapEl && !this._mapEl.dataset.mounted && getIn(window, ['google', 'maps'])) {
      const map = this._map = new window.google.maps.Map(this._mapEl, {
        center: {lat: -26, lng: 134},
        zoom: 4,
        disableDefaultUI: true,
        scaleControl: true,
        zoomControl: true,
        clickableIcons: false,
      });

      new window.google.maps.Geocoder().geocode({address: singleLineAddress}, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          map.fitBounds(results[0].geometry.viewport);
          this.updateMarker(results[0].geometry.location);
        }
      });

      window.google.maps.event.addListener(map, 'click', this.onSelectLocation);

      this._mapEl.dataset.mounted = 'true';
    }
  };

  updateMarker = (position) => {
    if (this._propertyMarker) {
      this._propertyMarker.setPosition(position);
    } else {
      this._propertyMarker = new window.google.maps.Marker({
        map: this._map,
        position,
        icon: {
          scaledSize: {width: 39, height: 33},
          url: propertyMarker,
        },
      });
    }
  };

  onSelectLocation = (e) => {
    e.stop();
    this.updateMarker(e.latLng);
  };

  onUpdateChange = (e, {checked}) => {
    this.setState({updateCorelogic: checked});
  };

  confirmLocation = () => {
    const {onSelectLocation} = this.props;
    const {updateCorelogic} = this.state;
    const position = this._propertyMarker.getPosition();
    onSelectLocation(position.lat(), position.lng(), updateCorelogic);
  };

  render() {
    const {open, singleLineAddress} = this.props;
    const {updateCorelogic} = this.state;

    return (
      <Modal className="LocationPickerMap" size="fullscreen" open={open}>
        <Modal.Header>Sorry, we couldn't locate this property on the map</Modal.Header>
        <Modal.Content>
          <p>Please confirm the location of this address by dropping the pin at the location of:</p>
          <h4><img src={propertyMarker} alt=""/> {singleLineAddress}</h4>
          <div className="map" ref={ref => {
            this._mapEl = ref;
            this.mountMaps();
          }}/>
        </Modal.Content>
        <Modal.Actions>
          <Checkbox label="Update Cotality" checked={updateCorelogic} onChange={this.onUpdateChange}/>
          <Button onClick={this.confirmLocation} primary>Confirm Location</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
